import React from "react";
import "./Ligas.css";

export default function Ligas({ ligas }) {
  return (
    <div className="ligas-container">
      {ligas.map((liga, i) => (
        <div key={i} className="liga-item">
          <img src={liga.flag} alt={liga.nome} />
          <span>{liga.nome}</span>
        </div>
      ))}
    </div>
  );
}
